import React from "react";
import { cn } from "../../lib/cn";

export function Divider({ children, orientation = "center", type, className }) {
  if (type === "vertical") {
    return (
      <span
        className={cn("mx-3 inline-block h-4 w-px shrink-0 bg-slate-200 align-middle", className)}
      />
    );
  }
  if (!children) {
    return <hr className={cn("my-4 border-slate-200", className)} />;
  }
  return (
    <div
      className={cn(
        "my-4 flex items-center gap-3 text-xs font-semibold uppercase tracking-wide text-slate-400",
        className
      )}
    >
      <span className="h-px flex-1 bg-slate-200" />
      {children}
      <span className="h-px flex-1 bg-slate-200" />
    </div>
  );
}
